import * as React from 'react';

export const Users = () => (
  <svg width='35px' height='44px' version='1.1' x='0px' y='0px' viewBox='0 0 48 60' enableBackground='new 0 0 48 48'>
    <g>
      <path
        className='navigation-icon-fill'
        d='M24,10c2.8,0,5-2.2,5-5s-2.2-5-5-5s-5,2.2-5,5S21.2,10,24,10z M24,2c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S22.3,2,24,2z'
      />
      <path
        className='navigation-icon-fill'
        d='M18,24h12c0.6,0,1-0.4,1-1v-4c0-3.9-3.1-7-7-7s-7,3.1-7,7v4C17,23.6,17.4,24,18,24z M19,19c0-2.8,2.2-5,5-5s5,2.2,5,5v3H19   V19z'
      />
      <path
        className='navigation-icon-fill'
        d='M41,34c2.8,0,5-2.2,5-5s-2.2-5-5-5s-5,2.2-5,5S38.2,34,41,34z M41,26c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S39.3,26,41,26   z'
      />
      <path
        className='navigation-icon-fill'
        d='M41,36c-3.9,0-7,3.1-7,7v4c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1v-4C48,39.1,44.9,36,41,36z M46,46H36v-3c0-2.8,2.2-5,5-5   s5,2.2,5,5V46z'
      />
      <path
        className='navigation-icon-fill'
        d='M7,34c2.8,0,5-2.2,5-5s-2.2-5-5-5s-5,2.2-5,5S4.2,34,7,34z M7,26c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S5.3,26,7,26z'
      />
      <path
        className='navigation-icon-fill'
        d='M7,36c-3.9,0-7,3.1-7,7v4c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1v-4C14,39.1,10.9,36,7,36z M12,46H2v-3c0-2.8,2.2-5,5-5   s5,2.2,5,5V46z'
      />
      <path
        className='navigation-icon-fill'
        d='M31.9,39.4l-6.9-6V27c0-0.6-0.4-1-1-1s-1,0.4-1,1v6.4l-6.9,6c-0.4,0.4-0.5,1-0.1,1.4c0.4,0.4,0.9,0.4,1.4,0.1l6.6-5.7   l6.6,5.7c0.4,0.4,1,0.3,1.4-0.1C32.4,40.4,32.4,39.7,31.9,39.4z'
      />
    </g>
  </svg>
);
